<template>
    <!-- Panel Derecho -->
    <b-col cols="12" md="4">
      <b-row>
        <b-col >
          <b-img src="/images/pages/novedades.svg" height="50" class="mr-2"></b-img>
          <br>
          <slot></slot>
        </b-col>
      </b-row>
    </b-col>
</template>
<script>
export default {
  name: "Recomendaciones"
};
</script>